import React from 'react';
import { Users, BookOpen, CheckSquare, Plus } from 'lucide-react';

export const TeacherClassroomModule: React.FC = () => {
  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm space-y-6">
      <div className="flex items-center justify-between border-b border-slate-100 pb-4">
        <div>
          <span className="px-2.5 py-0.5 bg-rose-100 text-rose-800 text-[10px] font-bold rounded-full uppercase tracking-wider">
            ClassDojo & Goalbook Benchmark
          </span>
          <h2 className="text-2xl font-bold text-slate-900 mt-1">Teacher Classroom & Inclusive Lesson Workspace</h2>
          <p className="text-xs text-slate-500">Adaptive lesson planning, classroom accommodations matrix, and student engagement</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="p-4 bg-slate-50 border border-slate-200 rounded-xl space-y-3">
          <h3 className="text-xs font-bold text-slate-700 uppercase tracking-wider flex items-center gap-1.5">
            <BookOpen className="w-4 h-4 text-rose-600" />
            Today's Adaptive Lesson Plan
          </h3>
          <div className="bg-white p-3 rounded-lg border border-slate-200 text-xs space-y-2">
            <div className="font-bold text-slate-900">Topic: Sensory Science Exploration</div>
            <p className="text-slate-600">Tactile soil & water experiment with AAC vocabulary prompts (Wet, Cold, Soft, Heavy).</p>
            <div className="flex gap-2">
              <span className="px-2 py-0.5 bg-rose-50 text-rose-700 text-[10px] font-bold rounded">Visual Supports</span>
              <span className="px-2 py-0.5 bg-blue-50 text-blue-700 text-[10px] font-bold rounded">AAC Board Ready</span>
            </div>
          </div>
        </div>

        <div className="p-4 bg-slate-50 border border-slate-200 rounded-xl space-y-3">
          <h3 className="text-xs font-bold text-slate-700 uppercase tracking-wider flex items-center gap-1.5">
            <CheckSquare className="w-4 h-4 text-emerald-600" />
            Accommodations Checklist
          </h3>
          <ul className="space-y-2 text-xs text-slate-700">
            <li className="flex items-center gap-2">
              <input type="checkbox" defaultChecked className="rounded text-rose-600" />
              <span>Extended Time (1.5x) for Reading Comprehension</span>
            </li>
            <li className="flex items-center gap-2">
              <input type="checkbox" defaultChecked className="rounded text-rose-600" />
              <span>Noise-Canceling Ear Defenders during Assembly</span>
            </li>
            <li className="flex items-center gap-2">
              <input type="checkbox" defaultChecked className="rounded text-rose-600" />
              <span>Slant Board & Ergonomic Grip Pencil</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
